import React from 'react';
import {Layout as RALayout} from 'react-admin';
import {ProjectMenu} from './project/ProjectMenu';
import AppBar from './AppBar';

export function Layout(props) {
  return <RALayout {...props} menu={ProjectMenu} appBar={AppBar}/>;
}
